import axios from './financeiroApi';

const PATH = '/api/v1/backend/empresas';

const empresaApi = {
  buscar: async (uuid) => {
    return axios.get(`${PATH}/${uuid}`);
  },

  buscarTodas: async (search) => {
    const url = `${PATH}?page=${search.page}&size=${search.size}${
      search.query ? `&query=${search.query}` : ''
    }&sort=ativo,desc&sort=${search.sort || 'pessoa.nome,asc'}`;
    return axios.get(url);
  },

  buscarEmpresasPorUsuario: async (search) => {
    const url = `${PATH}/empresas-usuarios?page=${search.page}&size=${search.size}${
      search.query ? `&query=${search.query}` : ''
    }&sort=ativo,desc&sort=${search.sort || 'pessoa.nome,asc'}`;
    return axios.get(url);
  },

  modalEmpresaSelecionar: (search) => {
    const url = `${PATH}/modal-selecionar-empresa?page=${search.page}&size=${search.size}${
      search.query ? `&query=${search.query}` : ''
    }${search.sort ? `&sort=${search.sort}` : ''}${search.ativo ? `&ativo=${search.ativo}` : ''}`;
    return axios.get(url);
  },

  selectEmpresa: (search) => {
    const url = `${PATH}/select-empresas?page=${search.page}&size=${search.size}${
      search.query ? `&query=${search.query}` : ''
    }${search.sort ? `&sort=${search.sort}` : ''}${search.ativo ? `&ativo=${search.ativo}` : ''}`;
    return axios.get(url);
  },

  buscarNome: async (uuid) => {
    return axios.get(`${PATH}/nome/${uuid}`, {
      responseType: 'text',
    });
  },

  cadastrar: async (empresa) => {
    return axios.post(`${PATH}`, empresa);
  },

  atualizar: async (uuid, empresa) => {
    return axios.put(`${PATH}/${uuid}`, empresa);
  },

  buscarLogoMarca: async (uuid) => {
    return axios.get(`${PATH}/download/${uuid}`);
  },

  uploadLogoMarca: async (formData) => {
    return axios.put(`${PATH}/logomarca/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        type: 'formData',
      },
    });
  },

  excluirLogoMarca: async (uuid) => {
    return axios.delete(`${PATH}/logomarca/${uuid}`);
  },

  atualizarEmpresaContexto: (uuid) => {
    return axios.put(`${PATH}/empresa-contexto/${uuid}`);
  },

  ativarInativar: (uuid, ativo) => {
    return axios.patch(`${PATH}/ativar-inativar/${uuid}?ativar=${ativo}`);
  },

  limiteEmpresa: (obrigatorioMaisDeUm) => {
    return axios.get(`${PATH}/limite?obrigatorioMaisDeUm=${obrigatorioMaisDeUm}`);
  },

  enviarEmailAlteracaoPlanoComercial: (comentarios) => {
    return axios.post(`${PATH}/alterar-plano-comercial/enviar-email`, comentarios, {
      headers: {
        origem: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
      },
    });
  },

  verificarServicoProdutoIbsCbs: () => {
    return axios.get(`${PATH}/possuiServicoProdutoIbsCbs`);
  },
};

export default empresaApi;
